export default __webpack_public_path__ + "static/media/flag_col.b5b39445.png";